import Image from "next/image";
import { useCallback } from "react";

type GridImageProps = {
  photo: string;
  productName: string;
  index: number;
  children?: React.ReactNode;
  handleImageClick?: (index: number) => void;
};

function GridImage({
  photo,
  productName,
  index,
  children,
  handleImageClick,
}: GridImageProps): JSX.Element {
  const handleImageLoad = useCallback(
    (event: React.SyntheticEvent<HTMLImageElement>) => {
      event.currentTarget?.parentElement?.setAttribute("data-loaded", "true");
    },
    []
  );

  const handleOnClick = useCallback(() => {
    if (handleImageClick) {
      handleImageClick(index);
    }
  }, [handleImageClick, index]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if ((event.key === "Enter" || event.key === " ") && handleImageClick) {
        event.preventDefault();
        handleImageClick(index);
      }
    },
    [handleImageClick, index]
  );

  return (
    <div
      key={`pdp-image-${index}`}
      className="image-container"
      onClick={handleOnClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      data-loaded="false"
    >
      <Image
        src={photo}
        alt={`${productName} ${index + 1}`}
        fill
        quality={100}
        onLoad={handleImageLoad}
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
      />
      {children}
    </div>
  );
}

export { GridImage };
